import React from "react";
import SectionList from "./sectionList";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default ({ content }) => {
  const alt = content.image?.alternativeText;
  return (
    <div id="featureSection">
      <div className="sectionLeft">
        <SectionList content={content.sectionList} />
      </div>
      <div className="sectionRight">
        <LazyLoadImage src={content.image?.url} alt={alt} effect="blur" />
      </div>
    </div>
  );
};
